import Vue from 'vue'
import VueRouter, { NavigationGuard } from 'vue-router'
import Home from '@/UI/Home/Home.vue'
import BidProceduresList from '@/UI/UserProcedures/BidProcedures/BidProceduresList.vue'
import WonProceduresList from '@/UI/UserProcedures/WonProcedures/WonProceduresList.vue'
import ProcedureDetail from '@/UI/Procedures/ProcedureDetail.vue'
import BidProcedureDetail from '@/UI/UserProcedures/BidProcedures/BidProcedureDetail.vue'
import WonProcedureDetail from '@/UI/UserProcedures/WonProcedures/WonProcedureDetail.vue'
import Review from '@/UI/UserProcedures/BidProcedures/Review/Review.vue'
import ProceduresList from '@/UI/Procedures/ProceduresList.vue'
import Auction from '@/UI/Auction/Auction.vue'
import AuctionB from '@/UI/AuctionB/AuctionB.vue'
import LoginResponse from '@/UI/Authentication/LoginResponse.vue'
import Error403 from '@/UI/Authentication/Error403.vue'
import NotFound from '@/UI/App/NotFound.vue'
import Help from '@/UI/App/Help.vue'
import Disabled from '@/UI/App/Disabled.vue'
import store from '@/Infrastructure/Store'
import { CheckSessionCommandHandlerProvider } from '@/Infrastructure/Account/Provider'
import { CheckSessionCommand } from '@/Application/Authentication'
import { Api410Error } from '@/Domain/ApiClient'
import { EventBus } from '../EventBus/EventBus'
import Tracking from '@/UI/Tracking/Tracking.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'home' },
      breadcrumbs: [],
      showBreadCrumbs: true
    }
  },
  {
    path: '/axuda',
    name: 'Help',
    component: Help,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'help' },
      breadcrumbs: [],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedementos-ofertados',
    name: 'PersonalBid',
    component: BidProceduresList,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'personalBid' },
      breadcrumbs: [],
      showBreadCrumbs: true
    }
  },
  {
    path: '/os-meus-procedementos',
    name: 'PersonalWon',
    component: WonProceduresList,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'personalWon' },
      breadcrumbs: [],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedementos',
    name: 'ProceduresList',
    component: ProceduresList,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'open-procedures' },
      breadcrumbs: [{ target: 'Home', label: 'Procedementos' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedemento/:procedureId/subasta',
    name: 'Auction',
    component: Auction,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'auction-a', params: 'procedureId' },
      breadcrumbs: [{ target: 'Home', label: 'Procedementos' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedemento/:procedureId/subastaB',
    name: 'AuctionB',
    component: AuctionB,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'auction-b', params: 'procedureId' },
      breadcrumbs: [{ target: 'ProceduresList', label: 'Procedementos' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedemento/:procedureId',
    name: 'ProcedureDetail',
    component: ProcedureDetail,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'procedure-detail', params: 'procedureId' },
      breadcrumbs: [{ target: 'ProceduresList', label: 'Procedementos' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/procedementos-ofertados/:procedureId',
    name: 'BidProcedureDetail',
    component: BidProcedureDetail,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'my-procedure', params: 'procedureId' },
      breadcrumbs: [{ target: 'PersonalBid', label: 'my-procedures' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/os-meus-procedementos/:numExpediente',
    name: 'WonProcedureDetail',
    component: WonProcedureDetail,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'my-expendiente', params: 'numExpediente' },
      breadcrumbs: [{ target: 'Home', label: 'my-expendientes' }],
      showBreadCrumbs: true
    }
  },
  {
    path: '/review/:procedureId',
    name: 'Review',
    component: Review,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'review-procedure', params: 'procedureId' },
      breadcrumbs: [
        { target: 'BidProcedureDetail', label: 'my-offers' }
      ],
      showBreadCrumbs: true
    }
  },
  {
    path: '/tracking/:procedureId',
    name: 'Tracking',
    component: Tracking,
    meta: {
      requiresAuth: true,
      pageTitle: { label: 'tracking', params: 'procedureId' },
      breadcrumbs: [{ target: 'Tracking', label: 'Tracking' }],
      showBreadCrumbs: false
    }
  },
  {
    path: '/login-response',
    name: 'LoginResponse',
    component: LoginResponse,
    meta: {
      requiresAuth: false,
      pageTitle: { target: 'Home', label: 'CheckCredentials' },
      showBreadCrumbs: false
    }
  },
  {
    path: '/inactive',
    name: 'Disabled',
    component: Disabled,
    meta: {
      fullWidth: true,
      requiresAuth: false,
      pageTitle: { target: 'Home', label: 'Unauthorized' },
      showBreadCrumbs: false
    }
  },
  {
    path: '/logged-out',
    name: 'Error403',
    component: Error403,
    meta: {
      fullWidth: true,
      requiresAuth: false,
      pageTitle: { target: 'Home', label: 'Unauthorized', params: 'from' },
      showBreadCrumbs: false
    }
  },
  {
    path: '*',
    component: NotFound,
    meta: {
      fullWidth: true,
      requiresAuth: false,
      pageTitle: { label: 'not-found' },
      showBreadCrumbs: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const checkSessionGuard: NavigationGuard = async (to, from, next) => {
  if (process.env.VUE_APP_API_ENV === 'local') {
    next()
    return
  }

  const accountId = store.getters['account/accountId'] || '12345678Z'
  const requiresAuth = to.meta && to.meta.requiresAuth === true
  if (!requiresAuth) {
    next()
    return
  }

  EventBus.$emit('loading', true)
  const provider = new CheckSessionCommandHandlerProvider()
  const command = new CheckSessionCommand(accountId)
  const handler = provider.provide()
  try {
    const response = await handler.handle(command)
    await store.dispatch('account/setAccountData', response)
    next()
  } catch (error) {
    await store.dispatch('account/logout')
    if (error instanceof Api410Error) {
      next({ name: 'Disabled' })
      return
    }
    // To avoid infinite loops
    if (to.name !== 'Error403') {
      next({ name: 'Error403', params: { from: from.path } })
    } else next()
  } finally {
    EventBus.$emit('loading', false)
  }
}

router.beforeEach(checkSessionGuard)

export default router
